var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchBlue = function SvgSearchBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.354 19.146a.5.5 0 0 1-.708.708l-3.708-3.709a7.5 7.5 0 1 1 .707-.707l3.709 3.708ZM17.5 10.5a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Z",
    fill: "#116DFF"
  })));
};
export default SvgSearchBlue;